/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopayEntry
 */
export interface CopayEntry {
    /**
     * 
     * @type {string}
     * @memberof CopayEntry
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CopayEntry
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof CopayEntry
     */
    note?: string;
}

/**
 * Check if a given object implements the CopayEntry interface.
 */
export function instanceOfCopayEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CopayEntryFromJSON(json: any): CopayEntry {
    return CopayEntryFromJSONTyped(json, false);
}

export function CopayEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopayEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CopayEntryToJSON(value?: CopayEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'note': value.note,
    };
}

